import { c as _c } from "react/compiler-runtime";
import { DialogInfoBar } from "@components/common/dialog-info-bar";
import { useTranslate } from "@faro-lotv/foreign-observers";
import { companyCreditBalanceSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { formatNumber } from "@utils/data-display";

/** Renders the info bar for transactions dialog */
export function TransactionsInfoBar() {
  const $ = _c(11);
  const creditBalance = useAppSelector(companyCreditBalanceSelector);
  const translate = useTranslate();
  let t0;
  if ($[0] !== creditBalance) {
    t0 = formatNumber(creditBalance);
    $[0] = creditBalance;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      label: "Balance",
      initialValue: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== translate) {
    t2 = translate("All time");
    $[4] = translate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      label: "Period",
      initialValue: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <DialogInfoBar items={[t1, t3]} />;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}